var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9124 8.2126L14.1374 8.21259C14.4757 8.21258 14.7499 7.93835 14.7499 7.60008C14.7499 7.2618 14.4756 6.98758 14.1374 6.98758L12.9124 6.98759C12.5741 6.9876 12.2999 7.26182 12.2999 7.6001C12.2999 7.93838 12.5741 8.2126 12.9124 8.2126Z",
    fill: "#8884A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39984 2.70006C7.39984 2.36178 7.67407 2.08755 8.01235 2.08756L14.1374 2.08757C14.4757 2.08757 14.7499 2.3618 14.7499 2.70007C14.7499 3.03835 14.4756 3.31257 14.1374 3.31257L8.01234 3.31256C7.67407 3.31256 7.39984 3.03833 7.39984 2.70006Z",
    fill: "#8884A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39984 12.5001C7.39984 12.1618 7.67407 11.8876 8.01235 11.8876L14.1374 11.8876C14.4757 11.8876 14.7499 12.1618 14.7499 12.5001C14.7499 12.8384 14.4756 13.1126 14.1374 13.1126L8.01234 13.1126C7.67407 13.1126 7.39984 12.8384 7.39984 12.5001Z",
    fill: "#8884A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.662314 3.31257L1.88732 3.31256C2.2256 3.31256 2.49982 3.03833 2.49982 2.70005C2.49981 2.36178 2.22558 2.08755 1.88731 2.08755L0.662302 2.08757C0.324027 2.08757 0.0498016 2.3618 0.0498051 2.70008C0.0498086 3.03835 0.324038 3.31258 0.662314 3.31257Z",
    fill: "#8884A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88732 13.1126L0.662314 13.1126C0.324038 13.1126 0.0498082 12.8384 0.0498047 12.5001C0.0498012 12.1618 0.324026 11.8876 0.662302 11.8876L1.88731 11.8876C2.22558 11.8876 2.49981 12.1618 2.49982 12.5001C2.49982 12.8384 2.2256 13.1126 1.88732 13.1126Z",
    fill: "#8884A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0498049 7.60008C0.0498049 7.26181 0.324032 6.98758 0.662308 6.98758H6.78734C7.12561 6.98758 7.39984 7.26181 7.39984 7.60008C7.39984 7.93836 7.12561 8.21259 6.78734 8.21259H0.662308C0.324032 8.21259 0.0498049 7.93836 0.0498049 7.60008Z",
    fill: "#8884A3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94983 0.862549C3.935 0.862549 3.11232 1.68523 3.11232 2.70006C3.11232 3.71489 3.935 4.53757 4.94983 4.53757C5.96466 4.53757 6.78734 3.71489 6.78734 2.70006C6.78734 1.68523 5.96466 0.862549 4.94983 0.862549Z",
    fill: "#8884A3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01234 7.60008C8.01234 6.58525 8.83502 5.76257 9.84985 5.76257C10.8647 5.76257 11.6874 6.58525 11.6874 7.60008C11.6874 8.61491 10.8647 9.43759 9.84985 9.43759C8.83502 9.43759 8.01234 8.61491 8.01234 7.60008Z",
    fill: "#8884A3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94983 10.6626C3.935 10.6626 3.11232 11.4853 3.11232 12.5001C3.11232 13.5149 3.935 14.3376 4.94983 14.3376C5.96466 14.3376 6.78734 13.5149 6.78734 12.5001C6.78734 11.4853 5.96466 10.6626 4.94983 10.6626Z",
    fill: "#8884A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.9322c0ab66deefdaee6f47e2c373e610.svg";
export { ForwardRef as ReactComponent };